import {useTranslation} from '@aboutyou/i18n';
import {COLORS, GenericIconName, Icon, Text} from '@aboutyou/ui-components';
import {styled as linariaStyled} from '@linaria/react';
import React from 'react';
import sc from 'styled-components';
import {PersonalizedFilterRow} from './PersonalizedFilterRow';
import {PersonalizedFilter} from './utils/usePersonalizedFiltersStore';

interface PersonalizedFilterListProps {
  personalizedFilters: PersonalizedFilter[];
  showSuccessMessage: boolean;
  deletePersonalizedFilter: (personalizedFilter: PersonalizedFilter) => void;
  closeDropdown: VoidFunction;
  appliedPersonalizedFilterId?: string;
}

export const PersonalizedFilterList: React.FC<PersonalizedFilterListProps> = ({
  personalizedFilters,
  showSuccessMessage,
  deletePersonalizedFilter,
  closeDropdown,
  appliedPersonalizedFilterId,
}) => {
  const {t} = useTranslation();

  return (
    <Wrapper>
      {personalizedFilters.length === 0 && (
        <EmptyState data-testid="personalizedFilterListEmpty">
          <StyledIcon asset={GenericIconName.YourFiltersHint} size="XL" />
          <EmptyText weight="bold">
            {t('You have no saved filters! :(')}
          </EmptyText>
        </EmptyState>
      )}

      {personalizedFilters.length > 0 &&
        personalizedFilters.map((filter, index) => (
          <PersonalizedFilterRow
            dataTestId={`personalizedFilterListRow-${index}`}
            key={filter.id}
            personalizedFilter={filter}
            showSuccessMessage={showSuccessMessage && index === 0}
            deletePersonalizedFilter={deletePersonalizedFilter}
            closeDropdown={closeDropdown}
            isFilterApplied={appliedPersonalizedFilterId === filter.id}
          />
        ))}
    </Wrapper>
  );
};

const Wrapper = sc.div`
  display: flex;
  flex-direction: column;
  width: 409px;
  max-height: 450px;
  overflow: hidden auto;
  border: 1px solid ${COLORS.Grey2};
  border-radius: 6px;
`;

const EmptyState = sc.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
`;

const EmptyText = sc(Text)`
  text-transform: uppercase;
`;

const StyledIcon = linariaStyled(Icon)`
  margin-right: 10px;
`;
